export const endPoints = {
    applyForJob : 'applyForJob',

    contact : 'contact',

    hireOurtalent : 'hireOurtalent',
}